import { SxProps, styled } from '@mui/material'

interface Props {
  size?: number
  className?: string
  sx?: SxProps
}
export function DotPulseLoading({ size = 10, className, sx }: Props) {
  return (
    <Container size={size} className={className} sx={sx}>
      <div />
      <div />
      <div />
    </Container>
  )
}

const Container = styled('div')<{ size: number }>`
  position: relative;
  width: ${({ size }) => 3 * size + 2 * Math.round(size / 3)}px;
  display: flex;
  gap: ${({ size }) => Math.round(size / 3)}px;

  div {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
    border-radius: ${({ size }) => Math.round(size / 2)}px;
    float: left;
    background: currentColor;
    transform: scale(0);
  }
  div:nth-child(1) {
    z-index: 1;
    animation: grow 3.5s infinite ease-in-out;
  }
  div:nth-child(2) {
    animation: grow 3.5s infinite ease-in-out;
    animation-delay: 0.2s;
  }
  div:nth-child(3) {
    animation: grow 3.5s infinite ease-in-out;
    animation-delay: 0.4s;
  }

  @keyframes grow {
    0% {
      transform: scale(0);
    }
    25% {
      transform: scale(1);
    }
    50% {
      transform: scale(0);
    }
    75% {
      transform: scale(1);
      background: currentColor;
    }
    100% {
      transform: scale(0);
      background: currentColor;
    }
  }
`
